import { PropertyReviewProps } from './PropertyRating.types';

export const PropertyReview = ({ className, isVisible, children }: PropertyReviewProps) => {
  return !isVisible ? <></> : typeof children === 'string' ? <span className={className}>{children}</span> : children;
};
